import type { Underlying } from 'models/underlying';
import type { UnderlyingCodeType } from 'models/underlying/base';
import { EquityUnderlying } from 'models/underlying/equity';

import { isCommodityUnderlying, isEquityUnderlying, isRateUnderlying } from './typeGuards';

export function getUnderlyingCode(underlying: Underlying, defaultUnderlyingCodeType: UnderlyingCodeType): string {
  if (isEquityUnderlying(underlying) || isCommodityUnderlying(underlying) || isRateUnderlying(underlying)) {
    switch (defaultUnderlyingCodeType) {
      case 'Bloomberg':
        return underlying.bloombergTickerCode ?? underlying.id;
      case 'Reuters':
        return underlying.reutersCode ?? underlying.id;
    }
  }

  return underlying.id;
}

export function getUnderlyingName(underlying: Underlying, defaultUnderlyingCodeType?: UnderlyingCodeType) {
  let name: string | undefined;
  if (isEquityUnderlying(underlying) || (isCommodityUnderlying(underlying) && defaultUnderlyingCodeType)) {
    switch (defaultUnderlyingCodeType) {
      case 'Bloomberg':
        name = underlying.bloombergTickerCode;
        break;
      case 'BloombergComposite':
        name = (underlying as EquityUnderlying).bloombergComposite;
        break;
      case 'Isin':
        name = underlying.isin;
        break;
      case 'Reuters':
        name = underlying.reutersCode;
        break;
      case 'MicCode':
        name = underlying.micCode;
        break;
    }
  }

  return name ?? underlying.name ?? underlying.id;
}
